// src/index.js
export { default } from './components/tool'


// WEBPACK FOOTER //
// ./src/index.js